import { combineReducers, configureStore } from '@reduxjs/toolkit';

import accountingReducer from './accounting.slice';
import driverReducer from './driver.slice';
import notificationReducer from './notification.slice';
import providerReducer from './provider.slice';
import referenceReducer from './reference.slice';
import tripPackageInventoryReducer from './tripPackageInventory.slice';
import tripReducer from './trip.slice';
import uiReducer from './ui.slice';
import userReducer from './user.slice';
import vehicleReducer from './vehicle.slice';
import passengerReducer from './passenger.slice';
import invoiceReducer from './invoice.slice';
import settingsReducer from './settings.slice';
const combinedReducer = combineReducers({
  accounting: accountingReducer,
  driver: driverReducer,
  notification: notificationReducer,
  provider: providerReducer,
  reference: referenceReducer,
  tripPackageInventory: tripPackageInventoryReducer,
  trip: tripReducer,
  ui: uiReducer,
  user: userReducer,
  vehicle: vehicleReducer,
  passenger: passengerReducer,
  invoice: invoiceReducer,
  settings: settingsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }

  return combinedReducer(state, action);
};
const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
